<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
export default                                                                                                                                                {
  name: 'App',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
  width: 1000px;
}
@media only screen and (min-width: 900px) {
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0 auto;
    width: 1000px; /*no*/
  }
  .content_item{
    display: flex;
    justify-content: flex-start;
    border: 1px solid transparent; /*no*/
    border-radius: 50px; /*no*/
    background-color: rgb(230,231,231); /*no*/
    color: rgb(224, 95, 64); /*no*/
    margin-top: 20px; /*no*/
    padding: 50px 50px; /*no*/
    flex-direction: column;
  }
  .content_title{
    font-size: 30px; /*no*/
  }
  .title_margin{
    margin-top: 35px; /*no*/
  }
  .content_item_title{
    color: white;
    border: 1px solid transparent; /*no*/
    background-color: rgb(224, 95, 64);
    border-radius: 50px; /*no*/
    padding: 10px 25px; /*no*/
  }
  .content_margin{
    margin-top: 20px; /*no*/
  }
  .content_pay_item {
    background-color: rgb(224, 95, 64);
    border-radius: 10px; /*no*/
    display: inline-block;
    text-align: center;
    padding: 6px; /*no*/
    cursor: pointer;
    margin-bottom: 20px; /*no*/
    margin-right: 20px; /*no*/
  }
  .flow li {
    line-height: 40px;  /*no*/
    background: #50abe4;
    display: inline-block;
    color: #fff;
    position: relative;
    text-align: center;
    margin-right: 8px;  /*no*/
    padding: 0px 200px 0px 30px;  /*no*/
    border-top-left-radius: 5px;  /*no*/
    border-bottom-left-radius: 5px;  /*no*/
  }
  .flow li::before {
    content: "";
    border-top: 20px solid #50abe4; /*no*/
    border-bottom: 20px solid #50abe4; /*no*/
    border-left: 20px solid white; /*no*/
    position: absolute;
    left: 0px; /*no*/
    top: 0;
  }
  .flow li::after {
    content: "";
    border-top: 20px solid transparent;  /*no*/
    border-bottom: 20px solid transparent; /*no*/
    border-left: 20px solid #50abe4; /*no*/
    position: absolute;
    right: -20px; /*no*/
    top: 0;
    z-index: 10;
  }
}
/*屏幕大小小于900*/
.flow li {
  line-height: 40px;
  background: #50abe4;
  display: inline-block;
  color: #fff;
  position: relative;
  text-align: center;
  margin-right: 8px;
  padding: 0px 20px 0px 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.flow li::before {
  content: "";
  border-top: 20px solid #50abe4;
  border-bottom: 20px solid #50abe4;
  border-left: 20px solid white;
  position: absolute;
  left: 0px;
  top: 0;
}

.flow li::after {
  content: "";
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 20px solid #50abe4;
  position: absolute;
  right: -20px;
  top: 0;
  z-index: 10;
}

.flow li:first-child::before {
  display: none;
}
.flow li.active{
  background-color: rgb(224, 95, 64)
}
.flow li.active::after{
  border-left-color: rgb(224, 95, 64)
}
.flow li.active::before{
  border-top-color: rgb(224, 95, 64);
  border-bottom-color: rgb(224, 95, 64);
}
.content_item{
  display: flex;
  justify-content: flex-start;
  border: 1px solid transparent;
  border-radius: 50px;
  background-color: rgb(230,231,231);
  color: rgb(224, 95, 64);
  margin-top: 20px;
  padding: 50px 50px;
  flex-direction: column;
}
.content_title{
  font-size: 30px; /*px*/
}
.title_margin{
  margin-top: 35px;
}
.content_item_title{
  color: white;
  border: 1px solid transparent;
  background-color: rgb(224, 95, 64);
  border-radius: 50px;
  padding: 10px 25px;
}
.content_margin{
  margin-top: 20px;
}
.content_pay_item {
  background-color: rgb(224, 95, 64);
  border-radius: 10px;
  display: inline-block;
  text-align: center;
  padding: 6px;
  cursor: pointer;
  margin-bottom: 20px;
  margin-right: 20px;
}
* {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue